// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__eXub1","text":"styles_text__3JlPQ","divIcon":"styles_divIcon__X4UKd","button":"styles_button__2OOWg","warning":"styles_warning__2VkLK"};